<!-- 
    COMPONENTE PARA SELECAO DO ESTAGIO
-->

<script>
import { apiORDSpost, apiORDS } from '../shared/api-functions'
import { SysVars } from '../main';
import Vue from 'vue';
import apiCrm from '../api/api-crm.js'

export default {
    props: {
        negocio: {},
        funil: {},
        negocioNovoForm: Boolean,
    },
    
    components: {

    },

    data () {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,

            selectedEtapa: null,
            
            etapaList: [ 
                { descricao: 'Cliente Potencial', probabilidade: 100, estagnado: 0, excluida: false, transfer_codetapa: null },
                { descricao: 'Contato Realizado', probabilidade: 100, estagnado: 0, excluida: false, transfer_codetapa: null },
                { descricao: 'Visita Técnica', probabilidade: 100, estagnado: 0, excluida: false, transfer_codetapa: null },
                { descricao: 'Proposta Feita', probabilidade: 100, estagnado: 0, excluida: false, transfer_codetapa: null },
                { descricao: 'Negociação em Andamento', probabilidade: 100, estagnado: 0, excluida: false, transfer_codetapa: null },
            ],

        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {

    },

    methods: {
        isActive (index) {
            if (this.selectedEtapa && this.etapaList[index].sequencia <= this.selectedEtapa.sequencia)
              return 'active' 
            else 
              return ''
        },

        handleSelectEtapa (index) {
            //efetua a gravacao da etapa selecionada
            this.selectedEtapa = this.etapaList[index]
            this.$emit('change', this.selectedEtapa)

            if (!this.negocioNovoForm) {
                let data = {
                        codnegocio: this.negocio.codnegocio, 
                        codetapa: this.etapaList[index].codetapa 
                    }
                this.apiNegocio(data, this.negocio.codnegocio, this.callBack)
            }
        },

        callBack (data) {
            //atualiza o codigo da etapa selecionada do objeto pai
            if (data) {
                this.negocio.codetapa = data.codetapa 
            }
        },

    },

    watch: {

    },

    mounted () {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
        })
    },

    created () {
        this.etapaList = this.funil.etapas

        for (var x = 0; x < this.etapaList.length; x++) {
            if (this.etapaList[x].codetapa == this.negocio.codetapa)
                this.selectedEtapa = this.etapaList[x]
        }

        //CARREGA O NR DE DIAS DAS ETAPAS
        if (this.negocio.dias_etapas) {
            let etapa = null
            for (var x = 0; x < this.etapaList.length; x++) {

                if (this.etapaList[x].sequencia > this.selectedEtapa.sequencia)
                  break

                etapa = this.negocio.dias_etapas.filter((obj) => {
                    return obj.codetapa === this.etapaList[x].codetapa
                })
                if (etapa.length > 0) {
                    this.etapaList[x].texto_dias = etapa[0].dias + ' dias'
                }
            }
        }

        console.log(this.etapaList)
    }

}

</script>

<template>
    <div class="pipelineSummary">
        <div class="row col align-itens-center">
            <v-label label="Selecione a Etapa do Negócio"></v-label>
        </div> 
        <div class="pipelineStages open">
            <ul>
                <li v-for="(etapa, index) in etapaList" :key="index" :class="isActive(index)" @click="handleSelectEtapa(index)"
                :title="etapa.descricao" data-toggle="tooltip" data-placement="top" style="height: 35px; clip-path: polygon(calc(100% - 6px) 0,100% 50%,calc(100% - 6px) 100%,2px 100%,8px 50%,2px 0);" >
                    <div class="stageContent">
                        <span class="stagename" v-if="etapa.texto_dias">{{ etapa.texto_dias }}</span>
                        <!-- <span class="stageArrow"></span> -->
                    </div>
                </li>
            </ul>
        </div> 

        <div class="row col align-itens-center">
            <span class="pipelineInfo mr-2"> {{ funil.descricao }} </span>
            <span class="pipelineInfo" v-if="selectedEtapa"><i class="fa fa-chevron-right mr-2"></i> {{ selectedEtapa.descricao }} </span>
            <span class="pipelineInfo" v-else><i class="fa fa-chevron-right mr-2"></i> Selecione uma etapa </span>
        </div>

    </div>          
</template>

<style>

.pipelineSummary {
    position: relative;
    height: auto;
}

.pipelineSummary .pipelineStages {
    position: relative;
    display: table;
    height: 24px;
    overflow: visible;
}

.pipelineSummary .pipelineStages ul {
    width: 100%;
    display: table;
    border-collapse: collapse;
    table-layout: fixed;
    height: 24px;
    -ms-box-sizing: border-box;
    -o-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
}

.pipelineSummary .pipelineStages ul li .stageContent {
    position: relative;
}

.pipelineSummary .pipelineStages ul li {
    position: relative;
    background: #e5e5e5;
    display: table-cell;
    text-align: left;
    line-height: 24px;
    vertical-align: middle;
    color: #fff;
    text-align: center;
    cursor: pointer;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.pipelineSummary .pipelineStages ul li:first-child {
    -moz-border-top-left-radius: 4px;
    border-top-left-radius: 4px;
    -moz-border-bottom-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.pipelineSummary .pipelineStages ul li .stageContent .stagename {
    font: 400 13px/16px Source Sans Pro,sans-serif;
    display: inline-block;
    position: relative;
    left: 4px;
}

.pipelineSummary .pipelineStages ul li .stageContent .stageArrow {
    width: 6px;
    height: 30px;
    position: absolute;
    top: -16px;
    left: 0;
    overflow: hidden;
}

.pipelineSummary .pipelineStages ul li .stageContent .stageArrow:after {
    width: 22px;
    height: 22px;
    position: absolute;
    right: -7px;
    top: 5px;
    border-top: 3px solid #fff;
    border-right: 3px solid #fff;
    transform: scaleX(.3) rotate(45deg);
    content: " ";
    cursor: pointer;
    background: #e5e5e5;
}

.pipelineSummary .pipelineStages.open ul li.active, .pipelineSummary .pipelineStages.open ul li.active .stageContent .stageArrow:after, .pipelineSummary .pipelineStages.won ul li.active, .pipelineSummary .pipelineStages.won ul li.active .stageContent .stageArrow:after {
    background: #174b79;
}


.pipelineSummary .pipelineStages.open ul li.active+li .stageContent .stageArrow:after, .pipelineSummary .pipelineStages.won ul li.active+li .stageContent .stageArrow:after {
    border-top: 3px solid #fff;
    border-right: 3px solid #fff;
    background: #174b79;
}

.pipelineSummary .pipelineStages ul li:first-child .stageContent .stageArrow {
    display: none;
}

</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-pipeline.vue